import { ElementRef, Injectable, Type, signal } from '@angular/core';
import { ConfirmComponent } from './confirm/confirm.component';

export type ModalCallbackProps = {
  ref: string;
  close: ModalCloseCallback;
  event: any;
};
export type ModalCloseCallback = () => void;
export type ModalOptions = {
  screen?: 'auto' | 'full' | 'aside';
  showCloseButton?: boolean;
  showPrintButton?: boolean;
  closeOnEscape?: boolean;
  focusOnOpen?: string | ElementRef;
  class?: string;
  componentClass?: string;
  onClose?: (ref?: string) => void;
  onBackdropClick?: (modal: ModalCallbackProps) => void;
  onCloseButtonClick?: (modal: ModalCallbackProps) => void;
  onOkButtonClick?: (modal: ModalCallbackProps) => void;
  onEscape?: (modal: ModalCallbackProps) => void;
};

export type ModalData = {
  id: string;
  component: Type<any>;
  props?: any;
  options?: ModalOptions;
};

@Injectable({ providedIn: 'root' })
export class ModalService {
  private modals = signal<ModalData[]>([]);
  readonly allModals = this.modals.asReadonly();

  open(component: Type<any>, props?: any, options: ModalOptions = { screen: 'auto' }): string {
    const id = crypto.randomUUID();
    if (!options.screen) {
      options.screen = 'auto';
    }

    this.modals.update((list) => [...list, { id, component, props, options }]);
    return id;
  }

  close(id: string | undefined, withCallbacks = true) {
    if (!id) return;
    const modalToClose = this.modals().find((modal) => modal.id === id);
    this.modals.update((list) => list.filter((modal) => modal.id !== id));
    if (withCallbacks) {
      modalToClose?.options?.onClose?.(modalToClose.id);
      // modalToClose?.options?.onBackdropClick?.();
      // modalToClose?.options?.onCloseButtonClick?.();
      // modalToClose?.options?.onEscape?.();
    }
  }

  confirm(title: string, content: string, okButtonText?: string, cancelButtonText?: string, color?: 'primary' | 'error'): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const id = this.open(
        ConfirmComponent,
        { title, content, okButtonText, cancelButtonText, color },
        {
          screen: 'auto',
          showCloseButton: false,
          closeOnEscape: false,
          focusOnOpen: undefined,
          onClose: () => {
            this.close(id, false);
            resolve(false);
          },
          onOkButtonClick: () => {
            this.close(id, false);
            resolve(true);
          },
        },
      );
    });
  }

  closeAll() {
    this.modals.set([]);
  }
}
